'use client'

import Link from 'next/link'

export default function ErrorPage({ reset }: { error: Error; reset: () => void }) {
  return (
    <section className="page-hero" style={{ minHeight: '60vh', display: 'grid', alignItems: 'center' }}>
      <div className="container">
        <p className="eyebrow">Erreur</p>
        <h1 className="underline-x">Un problème technique est survenu.</h1>
        <p className="lead">Nous n’avons pas pu afficher cette page. Merci de réessayer dans quelques instants.</p>
        <div className="btn-row" style={{ marginTop: 32 }}>
          <button type="button" className="btn" onClick={() => reset()}>
            Réessayer
          </button>
          <Link href="/" className="btn btn--ghost">
            Retour à l’accueil
          </Link>
        </div>
      </div>
    </section>
  )
}
